<ul class="sidebar-menu" nz-menu nzMode="inline">
  <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menus }"></ng-container>
  <ng-template #menuTpl let-menus>
    @for (menu of menus; track menu) { @if (!menu.children) {
    <li
      nz-menu-item
      [nzPaddingLeft]="menu?.level === 1 ? 1 : 12 * (menu?.level ?? 1)"
      [nzDisabled]="menu.disabled"
      nzMatchRouter
      [routerLink]="menu.route"
    >
      @if (menu.icon) {
      <span nz-icon [nzType]="menu.icon"></span>
      }
      <span nz-typography [nzContent]="menu.title | localization" nzEllipsis [nzEllipsisRows]="1">
      </span>
    </li>
    } @else {
    <li
      nz-submenu
      [nzPaddingLeft]="menu?.level === 1 ? 1 : 12 * (menu?.level ?? 1)"
      [nzOpen]="menu.open"
      [nzTitle]="menu.title | localization"
      [nzIcon]="menu.icon"
      [nzDisabled]="menu.disabled"
    >
      <ul>
        <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.children }" />
      </ul>
    </li>
    } }
  </ng-template>
</ul>
